import { Observable } from 'rxjs';
import {
    CartStep2ProductInterface,
    CartStep2ProductResponseInterface,
} from '../models/cart-step2-product.model';

export abstract class CartStep2ProductRepository {
    abstract sendCartStep2Product(
        array: CartStep2ProductInterface,
    ): Observable<CartStep2ProductResponseInterface>;
}
